//allows letters,numbers checks @ sign, chars after .(.com,.dk)
export const emailRegexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
//allows more then 2 letters, spaces
export const fullNameRegexp = /^([a-zA-Z0-9]+|[a-zA-Z0-9]+\s{1}[a-zA-Z0-9]{1,}|[a-zA-Z0-9]+\s{1}[a-zA-Z0-9]{3,}\s{1}[a-zA-Z0-9]{1,})$/;

export const PhoneRegexp = /\+45(?:\s[0-9]{2}){4}/i;
